module.exports = __webpack_public_path__ + "static/media/200euro.a653b129.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupures/200euro.jpg
// module id = 934
// module chunks = 0